import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'
import styled, { css } from 'styled-components'

import { Link } from '@utils/cook/types'

import Footer from '../Footer'
import Header from '../Header'
import Numbers from '../Numbers'
import { EuromillionsData } from '../types'

interface EuromillionsProps {
  data: EuromillionsData
  link: Link
}

const Table = dynamic(() => import('../Table'))

const StyledEuromillions = styled.div`
  ${({
    theme: {
      colors: { fillWeak },
      spacing: { spacing20 },
    },
  }) => css`
    padding: ${spacing20} ${spacing20} 15px ${spacing20};
    background-color: ${fillWeak};
    margin-bottom: ${spacing20};
  `}
`

const Euromillions: FunctionComponent<EuromillionsProps> = ({ data, link }) => {
  const {
    numbers,
    'adjunct-numbers': adjunctNumbers,
    'formatted-jackpot': jackpot,
    'next-draw-date': nextDate,
    'draw-date': drawDate,
  } = data
  return (
    <StyledEuromillions>
      <Header title="EuroMillions" drawDate={drawDate} id="euromillions" />
      <Numbers numbers={numbers} adjunctNumbers={adjunctNumbers} />
      <Table lottoData={data} id="euromillions" />
      <Footer link={link} jackpot={jackpot} nextDate={nextDate} />
    </StyledEuromillions>
  )
}

export default Euromillions
